import { Entity, Schema } from '@technocom/data/core';
import { Citizenship } from '@app/shared/models/dictionaries/citizenship';
import { Purpose } from '@app/shared/models/dictionaries/purpose';
import { Residence } from '@app/shared/models/dictionaries/residence';

export class ProfileInfo extends Entity<ProfileInfoDTO, number> {
  static readonly schema: Schema = Entity.extend<ProfileInfoDTO>({
    fields: {
      citizenship: {
        type: Citizenship,
        title: 'Гражданство',
      },
      birthYear: {
        type: Number,
        title: 'Год рождения',
      },
      purpose: {
        type: Purpose,
        title: 'Цель визита',
      },
      entryDate: {
        type: Date,
        title: 'Дата въезда в страну',
      },
      arrivalDate: {
        type: Date,
        title: 'Дата прибытия в место пребывания',
      },
      residenceDocument: {
        type: Residence,
        title: 'Отметка о наличии документа для проживания на территории РФ',
      },
      plannedPeriod: {
        type: Number,
        title: 'Планируемый срок прибывания на территории РФ (в днях)',
      },
      previouslyRegisteredChanged: {
        type: Boolean,
        title: 'Ранее уже состоял на миграционном учете в РФ, но сменил место регистрации',
      },
      hasFingerprint: {
        type: Boolean,
        title: 'Отметка о прохождении дактилоскопической регистрации',
      },
      hasMedicalPolicy: {
        type: Boolean,
        title: 'Отметка о наличии полиса обязательного или дополнительного мед страхования',
      },
      hasEducation: {
        type: Boolean,
        title: 'Отметка о наличии документа об образовании',
      },
      arrivalRegistrationDate: {
        type: Date,
        title: 'Дата прибытия в новое место',
      },
    },
  });
}

export interface ProfileInfoDTO {
  citizenship: Citizenship;
  birthYear: number;
  purpose: Purpose;
  entryDate: Date;
  arrivalDate: Date;
  residenceDocument: Residence;
  plannedPeriod: number;
  previouslyRegisteredChanged: boolean;
  hasFingerprint: boolean;
  hasMedicalPolicy: boolean;
  hasEducation: boolean;
  arrivalRegistrationDate: Date;
}
